import React, {useState, useEffect} from "react";
import {Container, Row} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import ApiService from "../util/ApiService";
import LoadingScreen from "../util/LoadingScreen";
import Swal from "sweetalert2";
import Skeleton from "react-loading-skeleton";
import {Avatar, Button, DatePicker, Input, Pagination} from "antd";
import "react-loading-skeleton/dist/skeleton.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {Modal} from "bootstrap";
import Select from 'react-select'; // Importação correta do Select
// Modais importados
import ModalNewAccreditation from "./ModalNewAccreditation";
import ModalPendingDocuments from "./ModalPendingDocuments";
import ModalConsent from "./ModalConsent";
import ModalRemakeDocuments from "./ModalRemakeDocuments";
import moment from "moment/moment";
import locale from "antd/es/date-picker/locale/pt_BR";
import {Link} from "react-router-dom";

moment.locale('pt-br');
const {RangePicker} = DatePicker; // Definir RangePicker para usar na seleção de data

const AccreditationUsers = () => {
    document.title = "Credenciamento | Plantão Rápido";
    // Estados principais
    const [users, setUsers] = useState([]);
    const [arrayCompany, setArrayCompany] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingPage, setLoadingPage] = useState(false);
    const [pagination, setPagination] = useState({current: 1, pageSize: 10, total: 0, lastPage: 0});
    const [effectRan, setEffectRan] = useState(false);
    // Estados para modais
    const [modalNewAccreditationVisible, setModalNewAccreditationVisible] = useState(false);
    const [modalPendingDocumentsVisible, setModalPendingDocumentsVisible] = useState(false); // Adicionando modal de documentos pendentes
    const [modalConsentVisible, setModalConsentVisible] = useState(false); // Adicionando modal de consentimento

    const [rejectedDocs, setRejectedDocs] = useState([]);
    const [rejectObservation, setRejectObservation] = useState("");
    const [showRemakeModal, setShowRemakeModal] = useState(false);
    const [rejectedDocumentData, setRejectedDocumentData] = useState(null);
    const statusOptions = [
        {value: 'pending', label: 'Pendente'},
        {value: 'approved', label: 'Aprovado'},
        {value: 'rejected', label: 'Rejeitado'},
        {value: 'remake', label: 'Reenviar Documentação'},
    ];
    // Estados para filtros de busca
    const [searchFilters, setSearchFilters] = useState({
        name: "",
        state: "",
        city: "",
        dateRange: [],
        status: "",
        company: "",
    });

    const [modalFilters, setModalFilters] = useState({
        name: "",
        state: "",
        city: "",
    });


    useEffect(() => {
        if (!effectRan) {
            fetchArrayCompany(false);
            setEffectRan(true);
        }
    }, [pagination.current, showRemakeModal]);

    // Função para buscar empresas
    const fetchArrayCompany = async (isExport = false) => {
        // Define o estado de carregamento com base no tipo de operação
        if (isExport) {
            setLoadingPage(true);
        } else {
            setLoading(true);
        }

        try {
            // Define o tipo de resposta com base em isExport
            const responseType = isExport ? 'blob' : 'json';

            // Chamada da API com configuração do responseType
            const response = await ApiService.send("get", `${process.env.REACT_APP_URL_API}documents/getfromuser`, {
                pagination: pagination.pageSize,
                page: pagination.current,
                dateRange: searchFilters.dateRange ? searchFilters.dateRange.map(date => date.toISOString()) : [],
                situation: searchFilters.status,
                company: searchFilters.company,
                export: isExport,
            }, true, responseType);

            if (isExport) {
                // Processa o download do arquivo Excel
                const blob = new Blob([response], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                const downloadUrl = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = `accreditation_users_${new Date().toISOString().split('T')[0]}.xlsx`;
                link.click();
                URL.revokeObjectURL(downloadUrl);
            } else {
                // Atualiza os dados de exibição se não for exportação
                const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
                setArrayCompany(data || []);
                setPagination(pagInfo || {current: 1, pageSize: 10, total: 0});

            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            // Finaliza o estado de carregamento
            if (isExport) {
                setLoadingPage(false);
            } else {
                setLoading(false);
            }
        }
    };


    // Função para abrir a modal de novo credenciamento
    const handleModalOpen = () => {
        setModalNewAccreditationVisible(true);
        const modal = new Modal(document.getElementById('newAccreditationModal'));
        modal.show();
    };


// Função para buscar dados e armazenar no estado consolidado
    const handleRemakeRequest = async (company) => {
        setLoadingPage(true);
        try {
            const response = await ApiService.send("get", `${process.env.REACT_APP_URL_API}documents/docrejectedlist`, {id_doc_accept_user: company.id});

            // Consolidar os dados de "rejectedData" e "pending" em uma variável única
            const {data} = ApiService.handleApiResponse(response);

            const rejectedData = data.rejectedData;
            const pendingDocuments = data.pending;

            // Armazenar no estado único
            setRejectedDocumentData({
                rejectedData: rejectedData,
                pendingDocuments: pendingDocuments,
            });

            // Caso precise extrair observação ou outros dados específicos
            setRejectObservation(rejectedData.comment || '');
            setShowRemakeModal(true);
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingPage(false);
        }
    };


    // Função para cancelar uma solicitação
    const handleCancelRequest = async (companyId) => {
        try {
            setLoadingPage(true);
            await ApiService.send("delete", `${process.env.REACT_APP_URL_API}documents/removemyrequest`, {user_id: companyId});
            Swal.fire({
                title: "Sucesso!",
                text: "Solicitação de credenciamento cancelada com sucesso.",
                icon: "success",
                confirmButtonText: "OK",
            });
            fetchArrayCompany();
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingPage(false);
        }
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Empresas" pageTitle="Credenciamento"/>
                    <Row>
                        {loadingPage && <LoadingScreen/>}




                                                <div className="row mt-4 mb-4">
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label>Data</label>
                                                            <div className="form-control">
                                                                <RangePicker
                                                                    style={{border: "none", boxShadow: "none"}}
                                                                    variant="outlined"
                                                                    locale={locale}
                                                                    format="DD/MM/YYYY"
                                                                    className="range-picker-custom"
                                                                    value={searchFilters.dateRange}
                                                                    onChange={(dates) =>
                                                                        setSearchFilters(prev => ({
                                                                            ...prev,
                                                                            dateRange: dates ? [dates[0], dates[1]] : []
                                                                        }))
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label>Situação</label>
                                                            <Select
                                                                placeholder="Selecione Status"
                                                                style={{width: "100%"}}
                                                                options={statusOptions}
                                                                onChange={(selectedOption) =>
                                                                    setSearchFilters((prev) => ({
                                                                        ...prev,
                                                                        status: selectedOption?.value || "",
                                                                    }))
                                                                }
                                                                menuPortalTarget={document.body} // Renderiza o menu no body
                                                                styles={{
                                                                    menuPortal: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999, // Garante que o dropdown fique no topo
                                                                    }),
                                                                }}
                                                            />

                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group" style={{position: 'relative'}}>
                                                            <label>Empresa</label>
                                                            <div className="hospital-input-group">
                                                                <Input
                                                                    placeholder="Selecione a empresa"
                                                                    value={searchFilters.company}
                                                                    onChange={(e) => setSearchFilters(prev => ({
                                                                        ...prev, company: e.target.value
                                                                    }))}
                                                                    className="form-control"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <div className="col-md-12 d-flex justify-content-end">

                                                        <button type="button" className="btn  me-2"
                                                                onClick={() => setSearchFilters({
                                                                    name: "",
                                                                    state: "",
                                                                    city: "",
                                                                    dateRange: [],
                                                                    status: "",
                                                                    company: ""
                                                                })}>
                                                            <i className="fa fa-eraser"></i> Limpar Filtros
                                                        </button>
                                                        <button type="button" className="btn btn-outline-primary me-2"
                                                                onClick={() =>handleModalOpen()}>
                                                            <i className="fa fa-plus"></i> Novo Credenciamento
                                                        </button>
                                                        <button type="button" className="btn btn-dark btn-s mr-1 me-2"
                                                                onClick={() => fetchArrayCompany(true)}>
                                                            <i className="fa fa-file-excel-o"></i> Exportar
                                                        </button>

                                                        <button type="button" className="btn btn-success "
                                                                onClick={() => fetchArrayCompany(false)}>
                                                            <i className="fa fa-search"></i> Buscar Solicitações
                                                        </button>
                                                    </div>
                                                </div>


                        <div className="list-container mt-4">
                            {loading ? (
                                <Skeleton count={3}/>
                                            ) : arrayCompany.length > 0 ? (
                                                arrayCompany.map((company) => (
                                                    <div key={company.id} className="duty-card shadow-sm mb-3">
                                                        <div className="card-body">
                                                            <div className="row">
                                                                <div className="duty-details col-10">
                                                                    <img
                                                                        src={company.user_profile_image || process.env.REACT_APP_URL_STORAGE + "src/perfil_icone.png"}
                                                                        alt={company.user_name}
                                                                        className="hospital-image"
                                                                        style={{width: "150px", height: "150px"}}/>
                                                                    <div className="ml-3">
                                                                        <h5>{company.user_name}</h5>
                                                                        <p>{company.user_email}</p>
                                                                        <p>{company.user_city} - {company.user_state}</p>
                                                                        <p>Solicitado: {new Date(company.created_at).toLocaleDateString()}</p>
                                                                        {company.due_date && (
                                                                            <p>Vencimento: {new Date(company.due_date).toLocaleDateString()}</p>
                                                                        )}
                                                                        <p>
                                                                            {company.situation === "pending" && (
                                                                                <span><i
                                                                                    className="fa fa-hourglass-half text-warning"></i> Pendente Análise</span>
                                                                            )}
                                                                            {company.situation === "accepted" && (
                                                                                <span><i
                                                                                    className="fa fa-check-circle text-success"></i> Aprovado</span>
                                                                            )}
                                                                            {company.situation === "cancel" && (
                                                                                <span><i
                                                                                    className="fa fa-close text-danger"></i> Cancelada</span>
                                                                            )}
                                                                            {company.situation === "refused" && (
                                                                                <span> <i
                                                                                    className="fa fa-times-circle text-danger"></i> Rejeitado</span>
                                                                            )}
                                                                            {company.situation === "remake" && (
                                                                                <span> <i
                                                                                    className="fa fa-edit text-warning"></i> Reenviar Informações</span>
                                                                            )}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className="duty-actions col-2 flex-column align-items-end justify-content-center">
                                                                    {(company.situation === "pending" || company.situation === "remake") && (
                                                                        <button type="button" className="btn btn-danger btn-sm mt-2"
                                                                                onClick={() => handleCancelRequest(company.user_id)}>
                                                                            <i className="fa fa-close"></i> Cancelar
                                                                        </button>
                                                                    )}
                                                                    {company.situation === "remake" && (
                                                                        <button type="button" className="btn btn-warning btn-sm mt-2"
                                                                                onClick={() => handleRemakeRequest(company)}>
                                                                            <i className="fa fa-file"></i> Reenviar
                                                                            Informação
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="alert alert-primary" role="alert">Nenhum plantão
                                                    encontrado.</div>
                                            )}
                                        </div>
                                        <Pagination
                                            current={pagination.current}
                                            pageSize={pagination.pageSize}
                                            total={pagination.total}
                                            onChange={(page) => setPagination({...pagination, current: page})}
                                        />



                        {/* Modal de Novo Credenciamento */}
                        <ModalNewAccreditation
                            show={modalNewAccreditationVisible}
                            onClose={() => setModalNewAccreditationVisible(false)}
                            modalFilters={modalFilters}
                            setModalFilters={setModalFilters}
                            fetchArrayCompany={fetchArrayCompany}
                        />

                        <ModalRemakeDocuments
                            show={showRemakeModal}
                            onClose={() => setShowRemakeModal(false)}
                            rejectedDocs={rejectedDocumentData?.pendingDocuments || []}
                            rejectObservation={rejectedDocumentData?.rejectedData.comment || ''}
                            onFileChange={(file, docId) => {
                                setRejectedDocumentData(prev => ({
                                    ...prev,
                                    pendingDocuments: prev.pendingDocuments.map(doc => doc.doc_id === docId ? {
                                        ...doc,
                                        file
                                    } : doc)
                                }));
                            }}
                            rejectedData={rejectedDocumentData?.rejectedData}
                        />
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default AccreditationUsers;
